<script>
import { Card } from "vant";
import { Image as VanImage } from "vant";
import { Switch } from "vant";
import { Col, Row } from "vant";
import { formatDateToYYYYMMDD, formatDateTime } from "@/ultis/dateFormat";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    package_active: {
      type: String,
      required: false,
    },
  },
  components: {
    [Card.name]: Card,
    [Image.name]: Image,
    [VanImage.name]: VanImage,
    [Switch.name]: Switch,
    [Col.name]: Col,
    [Row.name]: Row,
  },
  data() {
    return {
      checked: false,
      styleObject: {
        border: "1px solid rgb(196, 22, 39)",
      },
    };
  },
  computed: {
    content1() {
      if (this.data && this.data.content) {
        const parts = this.data.content.split("|");
        return parts[0] ? parts[0].trim() : "";
      }
      return "";
    },
    content2() {
      if (this.data && this.data.content) {
        const parts = this.data.content.split("|");
        return parts[1] ? parts[1].trim() : "";
      }
      return "";
    },
  },
  mounted() {
    this.checked = this.data.renew;
  },
  watch: {},
  methods: {
    processPhoneNumber(phoneNumber) {
      if (phoneNumber.startsWith("855")) {
        phoneNumber = phoneNumber.replace(/^\855/, "0");
      }

      return phoneNumber;
    },
    formatDateToYYMMDD(input, type) {
      if (type == "date") {
        return formatDateToYYYYMMDD(input);
      }
      if (type == "time") {
        return formatDateTime(input);
      }
      return "";
    },
    fixedPrice(price) {
      if (price) {
        price = Number(price);
        return price.toFixed(2);
      }
      return price;
    },
  },
};
</script>
<template>
  <div>
    <van-card
      :thumb="data.iconUrl"
      class="van-card-post tv360-home-item"
      :style="
        package_active && package_active == data.serviceCode ? styleObject : ''
      "
    >
      <template #tags>
        <van-row>
          <van-col span="24">
            <div
              class="d-flex van-row--justify-space-between van-row--align-center"
            >
              <h3 class="van-card__title">
                {{ data.serviceName }}
              </h3>
            </div>

            <!-- content1 -->
            <div v-if="content1" class="d-flex cs-van-tag">
              <van-tag
                plain
                type="danger"
                class="van-tag-icon"
                style="align-items: start; padding-top: 3px"
              >
                <div class="check-unit-box">
                  <p class="currency-unit">✓</p>
                </div>
              </van-tag>
              <van-tag plain type="danger" class="van-tag-day content-tag">
                {{ content1 }}
              </van-tag>
            </div>
            <!-- content2 -->
            <div v-if="content2" class="d-flex cs-van-tag">
              <van-tag
                plain
                type="danger"
                class="van-tag-icon"
                style="align-items: start; padding-top: 3px"
              >
                <div class="check-unit-box">
                  <p class="currency-unit">✓</p>
                </div>
              </van-tag>
              <van-tag plain type="danger" class="van-tag-day content-tag">
                {{ content2 }}
              </van-tag>
            </div>

            <!-- -->
            <div class="d-flex align-items-center cs-van-tag">
              <van-tag plain type="danger" class="van-tag-icon">
                <div class="currency-unit-box">
                  <p class="currency-unit">{{ data.unit }}</p>
                </div>
              </van-tag>
              <van-tag plain type="danger" class="van-tag-price">
                {{ fixedPrice(data.price) }}</van-tag
              >
              <van-tag plain type="danger" class="van-tag-day"
                >/ {{ data.validity }}</van-tag
              >
            </div>

            <!-- -->
          </van-col>
        </van-row>
      </template>
    </van-card>
  </div>
</template>

<style>
.check-unit-box {
  margin: 0;
  width: 14px;
  height: 14px;
  background: #ff0000;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
}

.tv360-home-item .cs-van-tag {
  margin-bottom: 2px;
}

.tv360-home-item .van-card__thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  box-sizing: border-box;
  overflow: hidden;
}

.tv360-home-item .van-card__thumb img {
  width: auto;
  height: 100%;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

.van-tag-icon {
  padding: 0;
  margin-right: 4px;
}

.content-tag {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.32px;
  margin: 0;
  padding: 4px 0px;
  color: #272d37;
  width: 100%;
  max-height: -moz-fit-content;
  max-height: fit-content;
}

/* Ensure the card aligns items center so the thumbnail is vertically centered */
.van-card-post.tv360-home-item,
.tv360-home-item.van-card-post {
  display: flex !important;
  /* align-items: center !important;*/
  gap: 12px;
  padding: 8px 12px !important;
}

.van-card-post.tv360-home-item .van-card__content,
.tv360-home-item.van-card-post .van-card__content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 !important;
}

.van-card-post.tv360-home-item .van-card__thumb,
.tv360-home-item.van-card-post .van-card__thumb {
  /*align-self: center;*/
}
</style>
